import { useState, useRef, useEffect } from "react";
import { ChevronDown, Check } from "lucide-react";
import { useSalaryBand } from "../../contexts/SalaryBandContext";

export default function SalaryGradeCombobox({ value, onChange }) {
  const { salaryBands } = useSalaryBand();
  const [query, setQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Convert name → ID if needed
  const normalizedValue =
    typeof value === "number"
      ? value
      : salaryBands.find((grade) => grade.name === value)?.id || "";

  const filteredGrades =
    query === ""
      ? salaryBands
      : salaryBands.filter((grade) =>
          grade.name.toLowerCase().includes(query.toLowerCase())
        );

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="mb-4" ref={dropdownRef}>
      <label className="block text-sm font-medium text-gray-700 dark:text-white">
        Salary Grade <span className="text-red-500">*</span>
      </label>

      <div className="relative mt-1">
        <input
          type="text"
          value={
            query ||
            (salaryBands.find((grade) => grade.id === normalizedValue)?.name ||
              "")
          }
          onChange={(e) => {
            setQuery(e.target.value);
            setIsOpen(true);
          }}
          onClick={() => setIsOpen(true)}
          placeholder="Select or search..."
          className="w-full p-2 border border-gray-300 rounded-md dark:bg-gray-800 dark:text-white pr-10"
        />
        <ChevronDown
          className="absolute right-2 top-2.5 text-gray-400 pointer-events-none"
          size={18}
        />

        {isOpen && (
          <ul className="absolute z-10 mt-1 max-h-48 w-full overflow-auto rounded-md bg-white dark:bg-gray-800 shadow-lg border border-gray-200 dark:border-gray-700">
            {filteredGrades.length === 0 ? (
              <li className="px-3 py-2 text-gray-500 dark:text-gray-300">
                Nothing found
              </li>
            ) : (
              filteredGrades.map((grade) => (
                <li
                  key={grade.id}
                  className={`px-3 py-2 cursor-pointer flex items-center justify-between ${
                    normalizedValue === grade.id
                      ? "bg-blue-100 dark:bg-blue-600 text-blue-700 dark:text-white"
                      : "hover:bg-gray-100 dark:hover:bg-gray-700"
                  }`}
                  onClick={() => {
                    onChange(grade.id); // Always send ID
                    setQuery("");
                    setIsOpen(false);
                  }}
                >
                  {grade.name}
                  {normalizedValue === grade.id && <Check size={16} />}
                </li>
              ))
            )}
          </ul>
        )}
      </div>
    </div>
  );
}
